<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <span class="title">公司資料</span>
      <span class="must-fill-label">*必須填寫</span>
    </div>
    <AGCEditGroupInput v-model="inputVal.name"
                       :fieldName="'name'"
                       name="商户名稱"
                       label="商户名稱"
                       type="text"
                       required
                       disabled
                       rules="required"
                       @is-save="handleSaveBtn"
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.companyName"
                       :fieldName="'companyName'"
                       name="公司名稱"
                       label="公司名稱"
                       type="text"
                       required
                       disabled
                       rules="required"
                       :onSave="true"
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-if="role === 'admin' || inputVal.brandName"
                       v-model="inputVal.brandName"
                       :fieldName="'brandName'"
                       name="品牌名稱"
                       label="品牌名稱"
                       type="text"
                       disabled
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.brc"
                       :fieldName="'brc'"
                       name="商業登記號碼"
                       label="商業登記號碼"
                       :inputType="'brc'"
                       rules="required|brc"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.brcImage"
                       :fieldName="'brcImage'"
                       name="商業登記證"
                       label="商業登記證"
                       :inputType="'dropzone'"
                       rules="required"
                       type="text"
                       disabled
                       required
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.email"
                       :fieldName="'email'"
                       name="公司電郵"
                       label="公司電郵"
                       type="email"
                       required
                       disabled
                       rules="required|email"
                       :readOnly="readOnly || role !== 'admin'"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.hotline"
                       :fieldName="'hotline'"
                       name="公司聯絡電話"
                       label="公司聯絡電話"
                       type="tel"
                       disabled
                       rules="numeric|min:6|max:12"
                       :readOnly="readOnly || withHotline && !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.isUseWhatsApp"
                       :fieldName="'isUseWhatsApp'"
                       :inputType="'tick'"
                       class="whatsapp"
                       name="只限Whatsapp聯絡"
                       label="只限Whatsapp聯絡"
                       disabled
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.address"
                       :fieldName="'address'"
                       name="公司地址"
                       label="公司地址"
                       type="text"
                       disabled
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.website"
                       :fieldName="'website'"
                       name="公司網頁"
                       label="公司網頁"
                       type="text"
                       disabled
                       rules="url"
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.facebook"
                       :fieldName="'facebook'"
                       name="Facebook"
                       label="Facebook"
                       type="text"
                       disabled
                       rules="url"
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.instagram"
                       :fieldName="'instagram'"
                       name="Instagram"
                       label="Instagram"
                       type="text"
                       disabled
                       rules="url"
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.desc"
                       :fieldName="'desc'"
                       :inputType="'editorWithCompanyIntroTemplate'"
                       name="公司簡介"
                       label="公司簡介"
                       disabled
                       required
                       rules="required|maxWord:500"
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.promotion"
                       :fieldName="'promotion'"
                       name="商戶焦點"
                       label="商戶焦點"
                       :inputType="'textarea'"
                       disabled
                       :readOnly="readOnly || !(role === 'admin' || role === 'sale')"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.tags"
                       class="custom-tags"
                       :fieldName="'tags'"
                       :inputType="'businessNature'"
                       name="業務性質"
                       label="業務性質"
                       disabled
                       required
                       rules="required"
                       :merchant-tag-options="merchantTagOptions"
                       :merchant-sub-tag-options="merchantSubTagOptions"
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-model="inputVal.images"
                       :fieldName="'images'"
                       name="圖片集"
                       label="圖片集"
                       required
                       rules="required"
                       :inputType="'images'"
                       type="text"
                       disabled
                       :readOnly="readOnly"
    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import tagAndSubTagMixin from '@/mixins/merchant/tag-and-sub-tag';
import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';
import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  data: () => ({
    isUseWhatsAppOption: [
      { name: '是', id: 1 },
    ],
    test: true,
    withHotline: false,
  }),
  mixins: [formMixin, vModelMixin, tagAndSubTagMixin],
  props: {
    readOnly: Boolean,
  },
  components: {
    AGCEditGroupInput,
  },
  computed: {
    ...mapGetters(['role']),
  },
  mounted() {
    this.checkHotlineExist();
  },
  methods: {
    handleSaveBtn() {
      this.$emit('is-save');
    },
    checkHotlineExist() {
      if (this.inputVal.hotline > 0) {
        this.withHotline = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0;
  color: #3A4047;
}

.must-fill-label {
  float: right;
  font-size: 14px;
  color: #f54b4e;
  font-weight: 400;
}

.custom-tags {
  margin: 0px;

  ::v-deep {
    .custom-control-label {
      ::v-deep {
        &::before, &::after {
          left: 0;
        }
      }
    }
  @media (max-width: 576px) {
      label {
        &.custom-control-label{
          margin: 0px;
          padding: 10px 20px !important;
          margin-top: 0px;
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}

</style>
